<template>
  <div class="custom-ddl" >
    <label v-if="label"
           class="input-label"
           :class="{'regular': regularLabel}">{{ label }}</label>
    <div>
      <v-select
        class="custom-v-select"
        :id="id"
        @input="updateValue"
        :class="{ 'was-Invalidated': error }"
        :label="fieldname"
        :options="options"
        :value="value ? prefixText + value[fieldname] : prefixText"
        :disabled="disabled"
        :clearable="clearable"
        :placeholder="placeholder"
        :append-to-body="placementTop"
        :calculate-position="placementTop ? withPopper: ()=>{}">
        <template>
          <input
            class="vs__search"
            :required="required"
            :value="value"
            @input="$emit('input', $event.target.value)">
        </template>
      </v-select>
    </div>
    <error v-if="error"
           variant="no-border"
           :message="customErrorMsg"/>
  </div>
</template>

<style scoped>

  span.invalid:not(input) {
    color: #e85c5c;
  }

  .input-label {
    height: 19px;
    text-align: left;
    font: Bold 16px/21px Lato;
    letter-spacing: 0;
    color: #11291B;
    line-height:19px;
  }
  .input-label.regular {
    font-weight: 400;
  }
  .custom-ddl div .v-select .vs__dropdown-toggle {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 2px solid #c5cdcf;
    opacity: 1;
    height: 38px;
  }

  .custom-ddl .vs__dropdown-menu {
    background: #fff;
    border:none;
    position: relative;
  }
  .custom-ddl :placeholder-shown,
  .custom-ddl .vs__search::placeholder{
    color: #495057;
    opacity: 0.8;
    line-height: 1.6;
  }
  .custom-ddl span.vs__selected,
  .custom-ddl .vs__selected-options .vs__selected,
  .custom-ddl .vs__dropdown-menu .vs__dropdown-option {
    font-weight: 400 !important;
  }
  .custom-ddl .was-Invalidated{
    border-radius: 4px;
    border: 1px solid #ff0018;
  }

  .custom-error i{
    float: left;
    margin-top: 15px;
    margin-right: 10px;
    color: #e85c5c;
}
 .v-select.custom-v-select {
  background-color: white;
 }
 .v-select.custom-v-select.was-Invalidated{
   background-color: #f7d7da;
 }
 .custom-ddl >>> .v-select.drop-up.vs--open .vs__dropdown-toggle {
    border-radius: 0 0 4px 4px;
    border-top-color: transparent;
    border-bottom-color: rgba(60, 60, 60, 0.26);
  }
</style>

<script>
import Error from "@/components/common/Error";
import { createPopper } from '@popperjs/core';
export default {
  name: "CustomDropDown",
  meta: {
    description: "Componente común DropDown personalizado.",
    slots: {
      default: {
        type: "component",
        valid: []
      }
    }
  },
  components: {
    Error
  },
  props: {
    id: {
      type: String,
      default: () => "",
      meta: {
        description: 'Id del Componente CustomDropDown',
        example: 'IdCustomDropDown',
      }
    },
    options: {
      type: Array,
      default: function() {
        return [];
      },
      meta: {
        description: 'Posibilita elegir entre varias',
        example: '"[4, 8, 15, 16, 23, 42]',
      }
    },
    value: {
      type: Object,
      default: () => {},
      meta: {
        description: 'Parámetro de entrada del CustomDropDown',
        example: 'Texto requerido',
      }
    },
    label: {
      type: String,
      default: "",
      meta: {
        description: 'Control para mostrar texto',
        example: 'Texto requerido',
      }
    },
    prefixText: {
      type: String,
      default: "",
      meta: {
        description: 'Establece, texto de prefijo',
        example: 'Texto requerido',
      }
    },
    fieldkey: {
      type: String,
      required: true,
      meta: {
        description: 'Establece, clave de campo',
        example: 'id',
      }
    },
    fieldname: {
      type: String,
      required: true,
      meta: {
        description: 'Estable el nombre del campo',
        example: 'name',
      }
    },
    placeholder: {
      type: String,
      default: "",
      meta: {
        description: 'Texto de referencia para el CustomDropDown',
        example: 'Seleccione',
      }
    },
    required: {
      type: String,
      default: function() {
        return "";
      },
      meta: {
        description: 'Estado requerido',
        example: 'Texto requerido',
      }
    },
    error: {
      type: String,
      default: "",
      meta: {
        description: 'Estado Error',
        example: 'Texto requerido',
      }
    },
    disabled: {
      type: Boolean,
      required: false,
      meta: {
        description: 'Estado Disabled',
        example: 'true',
      }
    },
    customErrorMsg: {
      type: String,
      default: function() {
        return this.error;
      },
      meta: {
        description: 'Mensaje de error encontrado',
        example: 'Texto requerido',
      }
    },
    onSelectionChange: {
      type: Function,
      default: function() {},
      meta: {
        description: 'Establece cambio de selección',
        example: '(value) => { return value.toUpperCase() }',
      }
    },
    clearable: {
      type: Boolean,
      default: () => true,
      meta: {
        description: 'Estado que limpia en el contenedor',
        example: 'True',
      }
    },
    regularLabel: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Control para mostrar texto en regular',
        example: 'true',
      }
    },
    placementTop: {
      type: Boolean,
      default: ()=> false,
      meta: {
        description: 'Establece posicionamiento superior.',
        example: 'true',
      }
    }
  },
  computed:{
    placement(){
      return 'top'
    },
    valueText() {
      let text = "";
      if(this.value)
        {
          if(this.value[this.fieldname])
            text = this.value[this.fieldname];
          else if( this.value[this.fieldkey] != null && this.value[this.fieldkey] != undefined && this.options.length > 0)
          {
            let option =  this.options.find(x => x[this.fieldkey] == this.value[this.fieldkey]);
            text = option[this.fieldname];
          }
        }

      return text;
    }
  },
  methods: {
    updateValue(value) {
      this.onSelectionChange();
      this.$emit("input", value);
    },
    withPopper (dropdownList, component, {width}) {
      dropdownList.style.width = width;
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: 'offset', options: {
              offset: [0, -1]
            }
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn ({state}) {
              component.$el.classList.toggle('drop-up', state.placement === 'top')
            },
          }]
      });
      return () => popper.destroy();
    },
  }

};
</script>
